import { useMemo } from 'react';
import { FreeShippingItemListResponseDto } from '@tiendanube/common';
import { useListMobile } from 'App/hooks';
import { FreeShippingEndpoints } from 'domains/Marketing/FreeShipping/freeShippingApi';

export function useFreeShippingMobile() {
  const result = useListMobile<FreeShippingItemListResponseDto>({
    filters: { perPage: '20' },
    endpoint: FreeShippingEndpoints.getFreeShippingsListInf,
  });

  const ids = useMemo(
    () => result.data.map((current) => current.id),
    [result.data],
  );
  return { ...result, ids };
}
